import { easyScroll } from "@common/module/easy-scroll"
import { changeTopToPrefPageHash } from "@common/module/change-hash"
import {
  changeStepsNext,
  changeStepsPrev,
  changeStepsLoad,
} from "@common/module/change-steps"

easyScroll()
changeTopToPrefPageHash()
changeStepsNext()
changeStepsPrev()
changeStepsLoad()
